<template>
  <div class="login-page">
    <div class="login-box">
      <div v-if="browserType =='2'">
        <div class="login-tab-part">
          <div v-if="loginType == '0'" class="mine-middle-item tab-selected">账号密码登录</div>
          <div v-if="loginType != '0'" @click = "changeLoginType('0')" class="mine-middle-item">账号密码登录</div>
          <div  v-if="loginType == '1'" class="mine-middle-item tab-selected">手机验证码登录</div>
          <div v-if="loginType != '1'" @click = "changeLoginType('1')" class="mine-middle-item">手机验证码登录</div>
        </div>

        <div v-if="loginType == '1'">
          <div class="form-row">
            <div class="phone">
              <div class="img-phone">
                <img src="../assets/icon-login-phone.png">
                <input style="font-size: .28rem;width: 4rem" type="number" name="phone" v-model="phone" placeholder="您的手机号" @change="mobilePhone()"/>
              </div>
              <div class="phone-code" :class="{'wait-send': waitSend}" @click="sendCode()">{{sendButtonText}}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="code">
              <img src="../assets/icon-code.png">
              <input style="font-size: .28rem" type="number" name="code" v-model="code" placeholder="请输入验证码"/>
            </div>
          </div>
        </div>
        <div v-if="loginType == '0'">
          <div class="form-row">
            <div class="phone">
              <div class="img-phone">
                <img src="../assets/icon-login-username.png">
                <input style="font-size: .28rem" type="number" name="phone" v-model="phone" placeholder="用户名" @change="mobilePhone()"/>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="code">
              <img src="../assets/icon-code.png">
              <input style="font-size: .28rem" v-model="password" type="password" placeholder="请输入密码"/>
            </div>
          </div>
        </div>
        <div v-if="loginType == '0'" class="login-btn" @click="loginByPassword()">登录</div>
        <div v-if="loginType == '1'" class="login-btn" @click="loginByCode()">登录</div>
        <div class="login-footer-operation">
          <div class="register-btn" @click="register">快速注册</div>
          <div @click="forgetPassword">忘记密码</div>
        </div>
      </div>
      <div v-if="browserType == '1'" @click="toAuth" style="text-align: center">
        <img class="icon-wechat" src="../assets/icon-wechat-btn.png">
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import CodeService from '../service/phoneCode/CodeService'
  import session from '../utils/Session'
  import userService from '../service/customer/UserService'

  export default {
    name: 'Login',
    components: {

    },
    data () {
      return {
        phone:'',
        code:'',
        password:'',
        sendStatus: false,
        sendTime: 60,
        sendButtonText: '获取验证码',
        waitSend:false,
        loginType:'0',
        browserType:'1',//浏览器类型：微信：1，其他：2
        backUrl:''
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.backUrl = this.$route.query.backUrl || '';
      session.backUrl(this.backUrl);
      session.logout();

      if (this.global.loginType) {
        this.loginType = this.global.loginType;
        this.global.loginType = '';
      }
      this.checkBrowserType();
    },
    methods: {
      toAuth() {
        this.$router.push({name: 'Auth', params: {}});
      },
      mobilePhone() {
        let phone = this.phone;
        if (phone == '') {
          Toast('请输入手机号码！');
          return false;
        }
        let re = /^1\d{10}$/;
        if (re.test(phone)) {
          return true;
        } else {
          Toast('请输入11位手机号码！');
          return false;
        }
      },
      async sendCode() {//发送验证码
        if (!this.mobilePhone()) {
          return;
        }
        let phone = this.phone;
        this.sendStatus = true;
        let result = await CodeService.sendPhoneCode(phone, 1);
        if (result.code == '0') {
          Toast('验证码已发送至您的手机,请注意查收！');
          this.sendTime = 60;
          this.computeSendTime();
        } else {
          Toast('获取验证码失败');
        }
      },
      computeSendTime() {
        if (this.sendStatus) {
          if (this.sendTime == 0) {
            this.waitSend = false;
            this.sendStatus = false;
            this.sendButtonText = '重新获取'
          } else {
            this.waitSend = true;
            this.sendTime = this.sendTime - 1;
            this.sendButtonText = this.sendTime + '秒';
            setTimeout(() => {
              this.computeSendTime()
            }, 1000)
          }
        }
      },
      register() {
        this.global.loginType = this.loginType;
        this.$router.push({name: 'RegisterStepOne'});
      },
      forgetPassword() {
        this.global.loginType = this.loginType;
        this.$router.push({name: 'ForgetPassword'});
      },
      checkBrowserType() {
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          //微信浏览器
          this.browserType = '1';
        } else {
          this.browserType = '2';
        }
      },
      changeLoginType(type) {
        this.loginType = type;
      },
      async loginByPassword() {
        if (!this.mobilePhone()) {
          return;
        }
        let password = this.password;
        let phone = this.phone;
        if (password == null || password == '') {
          Toast('请输入密码!');
        } else {
          let res = await userService.passwordLogin(phone, password);
          if (res.code == '0') {
            session.accountToken(res.data);
            session.login(res.data);
            if (!this.backUrl) {
              this.$router.push({name: 'Home', params: {}});
            } else {
              this.$router.push(this.backUrl);
            }
          } else {
            Toast(res.msg);
          }
        }
      },
      async loginByCode() {
        if (!this.mobilePhone()) {
          return;
        }
        let code = this.code;
        let phone = this.phone;
        if (code == null || code == '') {
          Toast('请填写验证码！');
        } else {
          let result = await CodeService.checkPhoneCode(code, '1', phone);
          if (result.code == '0') {
            let res = await userService.phoneLogin(phone);
            if (res.code == '0') {
              session.accountToken(res.data);
              session.login(res.data);
              if (!this.backUrl) {
                this.$router.push({name: 'Home', params: {}});
              } else {
                this.$router.push(this.backUrl);
              }

            } else {
              Toast("登录失败，请稍后重试!");
            }
          } else {
            Toast('验证码错误');
          }
        }
      },
      WxAuth() {
        this.$router.push({name: 'Auth', params: {}});
      },
    }
  }
</script>
<style lang="scss">
  .border-bottom-style{
    border-bottom: solid 1px #d5dee2;
  }
  .login-page{
    margin-top: -1rem;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white url("../assets/icon-login-bg.png") no-repeat;
    background-size: 100%;
    font-size: 0.28rem;

  *::-webkit-input-placeholder { /* WebKit browsers*/
    color: #cecbca!important;
    font-size:.28rem!important;
  }
  *:-moz-placeholder {  /* Mozilla Firefox 4 to 18*/
    color: #cecbca!important;
    font-size:.28rem!important;
  }
  *::-moz-placeholder {  /* Mozilla Firefox 19+*/
    color: #cecbca!important;
    font-size:.28rem!important;
  }
  *:-ms-input-placeholder { /* Internet Explorer 10+*/
    color: #cecbca!important;
    font-size:.28rem!important;
  }
  }
  .login-box {
    width: 6.92rem;
    border-radius: 0.1rem;
    background: white;
    box-shadow: 0rem 0.02rem 0.07rem 0rem rgba(0, 0, 0, 0.1);
    .login-tab-part{
      display: flex;
      height: 0.7rem;
      line-height: 0.7rem;
      margin-left: 0.3rem;
      margin-bottom: 0.5rem;
      margin-top: 0.3rem;
      color: #7f7d7c;
      .mine-middle-item{
        margin-right: 0.29rem;
      }
      .tab-selected{
        color: #191818;
        font-weight: bold;
      }
    }

  .form-row {
    width: 6.52rem;
    height: 0.9rem;
    margin: 0 auto 0.28rem;
    display: flex;
    justify-content: space-between;
    .form-input-box {
      background-color: #F3F8FC;
      border-radius: 0.06rem;
      font-size: 0.28rem;
      color: #1B1E29;;
    }
    .phone {
      width: 100%;
      height: 100%;
      border-radius: 0.06rem;
      display: flex;
      justify-content: space-between;
      .img-phone {
        flex-grow: 1;
        display: flex;
        align-items: center;

        img {
          width: 0.28rem;
          height: 0.42rem;
          margin-right: 0.2rem;
          margin-left: 0.1rem;
        }

        input {
          width: 5.65rem;
          outline: none;
          padding-bottom: 0.3rem;
          border-bottom: solid 1px #e0dedc;
          margin-top: 0.3rem;
        }
      }

      .phone-code {
        width: 2.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.06rem;
        color: #feac00;
      }

    }
    .code {
      width: 100%;
      height: 100%;
      border-radius: 0.06rem;
      display: flex;
      align-items: center;
      img {
        width: 0.36rem;
        height: 0.42rem;
        margin-right: 0.2rem;
        margin-left: 0.1rem;
      }
      input {
        width: 5.65rem;
        outline: none;
        padding-bottom: 0.3rem;
        border-bottom: solid 1px #e0dedc;
        margin-top: 0.3rem;
      }
    }
  }

  .login-btn{
    width: 2.8rem;
    height: 0.8rem;
    margin: 0 auto;
    font-size: 0.36rem;
    color: white;
    text-align: center;
    line-height: 0.9rem;
    background-color: #feac00;
    border-radius: 0.8rem;
    margin-top: 0.8rem;
    margin-bottom: 0.4rem;
  }
  .login-footer-operation{
    width: 3rem;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding-bottom: 0.5rem;
    font-size: 0.28rem;
    color: #feac00;
  }
  .login-wechat-header{
    height: 1.04rem;
    line-height: 1.04rem;
    font-size: 0.34rem;
    color: #1d8ae7
  }
  .login-wechat-part{
    padding-top: 0.9rem;
    padding-bottom: 0.62rem;
    font-size: 0.24rem;
    color: #1d8ae7
  }
  .icon-wechat{
    width: 2.2rem;
    height: 2.2rem;
  }

  .WeChat{
    margin-top: 0;
    background-color: #1AAC19;
  }
  }
  .wait-send {
    pointer-events: none;
  }
</style>
